import styled from 'styled-components';
import { useEffect, useRef, useState } from 'react';
import PageTop from '../components/pageTop/PageTop';
import Footer from '../components/footer/Footer';
import LandingFooter from '../promotion/components/LandingFooter';
import SeminarProcedure from '../promotion/components/seminar/SeminarProcedure';
import Instructor from '../promotion/components/seminar/Instructor';
import Benefit from '../promotion/components/seminar/Benefit';
import Question from '../promotion/components/seminar/Question';
import { useNavigate } from 'react-router-dom';
import { copyUrl } from '../../utils/url';
import CopyButton from '../components/button/CopyButton';
import { isLogin } from '../../utils/auth';
import { useModal } from '../../context/ModalContext';

const footerData = [
  {
    title: '이벤트 공지사항',
    content: [
      '비회원의 경우 회원가입 시 스탠다드 무료체험 혜택 제공합니다.',
      '회원 가입 후 세미나 신청 시 2개월 기간 추가 쿠폰 증정합니다.\n단, 1년 스탠다드 유료 결제에만 해당됩니다.',
      '지급일자는 세미나 종료 후 1개월 이후 일괄 지급합니다.',
    ],
  },
  {
    title: '이벤트 유의사항',
    content: [
      '땅집고옥션 무료 세미나 이벤트는 참석자에게만 해당됩니다.',
      '땅집고옥션 회원이라면 1개 ID당 1회 발급 가능합니다.',
      '발급받은 쿠폰은 마이페이지 > 쿠폰함에서 확인 가능하며, 유효기간은 발급일로부터 14일입니다.',
      '쿠폰은 다른 쿠폰과 중복 사용 불가합니다.',
      '쿠폰을 적용한 상품 환불 시 추가 기간을 제외한 실 결제 금액으로 환불 처리 됩니다.',
      '별도의 고지 없이 해당 이벤트 조기 종료될 수 있습니다.',
    ],
  },
];

const footerMoreSection = [
  {
    title: '신청 방법',
    content: [
      '무료 세미나 신청 후 참석하시면 됩니다.',
      '1개월 이내 1년 스탠다드 유료 결제 시 확인 후 쿠폰을 지급합니다.',
    ],
  },
];

const questionsData = [
  {
    idx: '01',
    title: '정말 무료인가요? 나중에 비용 청구되지 않나요?',
    answser: '100% 무료입니다. 추가 비용은 전혀 없습니다.',
  },
  {
    idx: '02',
    title: '경매를 한 번도 안 해봤는데 이해할 수 있을까요?',
    answser:
      '걱정 마세요. 참가자의 60%가 경매 초보자입니다. 기초부터 차근차근 설명 드립니다.',
  },
  {
    idx: '03',
    title: '특강 후 강요나 압박은 없나요?',
    answser:
      '전혀 없습니다. 유료 전환은 100% 자율이며, 당일 강의를 듣고 결정하시면 됩니다.',
  },
  {
    idx: '04',
    title: '주차는 가능한가요?',
    answser:
      '주차 장소가 없어서 근처 유료 주차장을 이용하셔야 합니다. (성공회성당, 코리아나호텔)',
  },
  {
    idx: '05',
    title: '못 오면 자료라도 받을 수 있나요?',
    answser: '현장 참가자에게만 제공됩니다. 놓치지 마세요!',
  },
];

function Seminar() {
  const navigate = useNavigate();
  const { modalDispatch } = useModal();

  const [leftTime, setLeftTime] = useState({
    days: '00',
    hours: '00',
    minutes: '00',
  });

  const handleConfirmButton = () => {
    // if (!isLogin()) {
    //   modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
    //   return;
    // }
    window.open('https://naver.me/G6Q2Exla', '_blank');
  };

  useEffect(() => {
    const target = new Date('2025-10-23T15:00:00+09:00').getTime(); // KST 마감

    const calc = () => {
      const now = Date.now();
      let diff = Math.max(0, target - now);

      const DAY = 1000 * 60 * 60 * 24;
      const HOUR = 1000 * 60 * 60;
      const MIN = 1000 * 60;

      const days = Math.floor(diff / DAY);
      diff %= DAY;
      const hours = Math.floor(diff / HOUR);
      diff %= HOUR;
      const minutes = Math.floor(diff / MIN);

      const pad = (n: number) => String(n).padStart(2, '0');

      setLeftTime({
        days: pad(days),
        hours: pad(hours),
        minutes: pad(minutes),
      });
    };

    calc(); // 초기 계산
    const id = setInterval(calc, 60 * 1000); // 1분마다 갱신
    return () => clearInterval(id);
  }, []);

  return (
    <Component>
      <Container>
        <PageTop />

        <BottomFloating>
          <FloatingContent>
            <FloatingText>
              신청 마감까지
              <img
                src="/assets/images/icon/fire.png"
                alt="fire"
                width={16}
                height={16}
              />
            </FloatingText>
            <FloatingTimeWrapper>
              <FloatingLeftTime>{leftTime.days}일</FloatingLeftTime>
              <FloatingLeftTime>{leftTime.hours}시간</FloatingLeftTime>
              <FloatingLeftTime>{leftTime.minutes}분</FloatingLeftTime>
            </FloatingTimeWrapper>
          </FloatingContent>
          <FloatingButton onClick={handleConfirmButton}>
            무료 세미나 신청하기 {'>'}
          </FloatingButton>
        </BottomFloating>

        <Keyvisual>
          <Header>
            <img
              src="/assets/images/logo/zipgoai_logo_mobile_footer2.svg"
              alt=""
              width={45}
              height={24}
              onClick={() => navigate('/')}
            />
            <HeaderIconButton
              onClick={() => copyUrl('https://zipgoai.com/seminar2509')}
            >
              <img src="/assets/images/icon/share-white.svg" alt="" />
            </HeaderIconButton>
          </Header>
          <MainImg onClick={handleConfirmButton} />
          <LeftTimeSection>
            <LeftTimeTitle>
              <img src="/assets/images/icon/fire.png" alt="fire" />
              신청 마감까지
            </LeftTimeTitle>
            <LeftTimeWrapper>
              <LeftTime>{leftTime.days}일</LeftTime>
              <LeftTimeHour>{leftTime.hours}시간</LeftTimeHour>
              <LeftTime>{leftTime.minutes}분</LeftTime>
            </LeftTimeWrapper>
          </LeftTimeSection>
        </Keyvisual>

        <Section $padding={60} $bg="#000" $gap={40}>
          <SectionTitle $color="#FFFFFF">
            아직도 이렇게
            <br />
            경매하고 계신가요?
          </SectionTitle>
          <ProblemsWrapper>
            <Problems>
              <img src="/assets/images/promotion/seminar/x.svg" alt="x" />
              감으로 입찰가 결정
            </Problems>
            <Problems>
              <img src="/assets/images/promotion/seminar/x.svg" alt="x" />
              엑셀로 일일이 수익률 계산
            </Problems>
            <Problems>
              <img src="/assets/images/promotion/seminar/x.svg" alt="x" />
              혼자서 끙끙대며 정보 수집
            </Problems>
            <Problems>
              <img src="/assets/images/promotion/seminar/x.svg" alt="x" />
              NPL이 뭔지도 모른 채 일반 경매만
            </Problems>
            <Problems>
              <img src="/assets/images/promotion/seminar/x.svg" alt="x" />
              실패 후 에야 깨닫는 숨은 비용들
            </Problems>
          </ProblemsWrapper>
        </Section>

        <Section $padding={60} $bg="#000" $gap={24}>
          <img src="/assets/images/promotion/seminar/warn.svg" alt="warn" />
          <Warn>
            <WarnText>
              <span>
                “정보의 차이가
                <br />
                수익의 차이를 만듭니다.”
              </span>
            </WarnText>
            <WarnText>
              당신이 1시간 분석하는 동안,
              <br /> <span>AI는 전국을 분석</span>합니다!
            </WarnText>
          </Warn>
        </Section>

        <Section $bg="#182850" $padding={0}>
          <img
            src="/assets/images/promotion/seminar/section-divider-curve.png"
            alt=""
            width={240}
            height={44}
          />
        </Section>
        <Section $bg="#182850" $padding={80} $gap={40}>
          <SectionTitle $color="#F1F6FF">
            땅집고옥션
            <br />
            AI와 함께라면
          </SectionTitle>
          <CompareImg
            src="/assets/images/promotion/seminar/compare.png"
            alt=""
          />
        </Section>

        <Section $padding={80} $bg="#F0F0F0" $gap={40}>
          <ZipgoVideo
            controls
            poster="/assets/images/promotion/free/video_thumbnail.PNG"
          >
            <source
              src="/assets/images/promotion/free/introduce_zipgoai.mp4"
              type="video/mp4"
            />
            브라우저가 video 태그를 지원하지 않습니다.
          </ZipgoVideo>
          <SectionTitle $color="#000">
            국내 유일! AI 경매 분석 시스템 3대 핵심 기능
          </SectionTitle>
          <PointWrapper>
            <PointContainer>
              <InteractionVideo
                src="/assets/images/ai-search/Interaction.mp4"
                autoPlay
                loop
                muted
                playsInline
                controls
              />
              <PointContent>
                <PointTitle>
                  <PointTitleNumber>Point 01</PointTitleNumber>
                  똑똑한 AI챗봇 “땅집봇”
                </PointTitle>
                <PointDesc>
                  “강남 빌라 어때?”
                  <br />
                  “365일 24시간 대기 중"
                </PointDesc>
              </PointContent>
            </PointContainer>
            <PointContainer>
              <PointImgWrapper>
                <PointImg
                  src="/assets/images/promotion/seminar/algo-mokup.png"
                  alt="algo"
                />
                <img
                  src="/assets/images/promotion/seminar/algo-mokup2.png"
                  alt="algo"
                  width={320}
                  style={{ position: 'absolute', top: '262px', left: '-30px' }}
                />
              </PointImgWrapper>
              <PointContent>
                <PointTitle>
                  <PointTitleNumber>Point 02</PointTitleNumber>
                  나만의 투자 정보
                  <br />
                  “AI 패턴 분석 시스템”
                </PointTitle>
                <PointDesc>
                  나만의 AI 알고리즘 생성으로
                  <br />
                  맞춤형 추천 물건 발굴!
                  <br />
                  검증된 빅데이터 전략으로
                  <br />
                  복잡한 설정 없이 바로 시작!
                </PointDesc>
              </PointContent>
            </PointContainer>
            <PointContainer>
              <PointImgWrapper>
                <PointImg
                  src="/assets/images/promotion/seminar/quant-mokup.png"
                  alt="quant"
                />
                <img
                  src="/assets/images/promotion/seminar/quant-mokup2.png"
                  alt="quant"
                  width={158}
                  style={{ position: 'absolute', top: '58px', right: '-22px' }}
                />
                <img
                  src="/assets/images/promotion/seminar/quant-mokup3.png"
                  alt="quant"
                  width={158}
                  style={{ position: 'absolute', top: '292px', left: '-22px' }}
                />
              </PointImgWrapper>
              <PointContent>
                <PointTitle>
                  <PointTitleNumber>Point 03</PointTitleNumber>
                  “퀀트 투자기반 테마 분석 시스템”
                </PointTitle>
                <PointDesc>
                  데이터가 말하는 진짜 수익
                  <br />
                  12가지 검증 된 전략 포트폴리오
                  <br />
                  실시간 시장 변화 반영 자동 업데이트
                </PointDesc>
              </PointContent>
            </PointContainer>
          </PointWrapper>
        </Section>

        <Section $padding={100} $bg="#fff" $gap={40}>
          <SeminarProcedureHeader>
            <SectionTitlePretendard>
              땅집고옥션 파헤치기!
            </SectionTitlePretendard>
            <SeminarProcedureHeaderDesc>
              <img
                src="/assets/images/icon/calendar-outline.svg"
                alt="calendar"
              />
              2025년 10월 24일 수요일 오후 2시 ~ 4시20분
            </SeminarProcedureHeaderDesc>
            <SeminarProcedureHeaderDesc>
              <img
                src="/assets/images/icon/location-outline-black.svg"
                alt="location"
              />
              땅집고 아카데미 강의장 (시청역 3번 출구 도보 5분)
            </SeminarProcedureHeaderDesc>
          </SeminarProcedureHeader>
          <SeminarProcedure />
        </Section>

        <Section $padding={100} $bg="#0CA8B1" $gap={60}>
          <SectionTitlePretendard $color="#fff" $center>
            강사진 소개
          </SectionTitlePretendard>
          <Instructor />
        </Section>

        <Section $bg="#F1FEFF" $padding={0}>
          <img
            src="/assets/images/promotion/seminar/section-divider-curve2.png"
            alt=""
            width={240}
            height={44}
          />
        </Section>

        <Section $bg="#F1FEFF" $padding={40} $gap={40} $paddingBottom={100}>
          <SectionTitlePretendard $center>
            세미나 참가자만을 위한 파격 혜택
          </SectionTitlePretendard>
          <Benefit />
        </Section>

        <Section $bg="#fff" $padding={100} $gap={40}>
          <SectionTitlePretendard>자주 묻는 질문</SectionTitlePretendard>
          <Question questions={questionsData} />
        </Section>

        <Section $bg="#000" $padding={100} $gap={40}>
          <SectionTitlePretendard $center $color="#00F0FF">
            “경매로 인생을 바꿀
            <br />단 한 번의 기회”
          </SectionTitlePretendard>
          <CheckboxContainer>
            <CheckBox>
              <img src="/assets/images/check/check-green.svg" alt="check" />
              국내 최초 AI & 퀀트 기반
              <br />
              경매·부실채권 투자 교육
            </CheckBox>
            <CheckBox>
              <img src="/assets/images/check/check-green.svg" alt="check" />
              단순 지식 전달이 아닌 실습·시뮬레이션·실제 물건 분석 중심
            </CheckBox>
            <CheckBox>
              <img src="/assets/images/check/check-green.svg" alt="check" />
              처음 경험하는
              <br />
              AI를 활용한 정보 시스템
            </CheckBox>
          </CheckboxContainer>
        </Section>

        <Section $bg="#fff" $padding={100} $gap={40}>
          <SectionTitlePretendard>
            행사 장소 및 교통 안내
          </SectionTitlePretendard>
          <Map src="/assets/images/promotion/seminar/map.png" alt="지도" />
          <LocationContainer>
            <LocationWrapper>
              <Location>
                <img src="/assets/images/icon/location-black.svg" alt="" />
                서울 중구 세종대로 21길 22, 2층
              </Location>
              <CopyButton
                name="주소복사"
                value="서울 중구 세종대로 21길 22, 2층"
              />
            </LocationWrapper>
            <Location>
              <Subway1>1</Subway1>
              시청역 3번 출구 도보 5분 (226m)
            </Location>
          </LocationContainer>
          <MapButtonWrapper>
            <MapButton
              onClick={() => window.open('https://naver.me/Gq8lEJK4', '_blank')}
            >
              <img
                src="/assets/images/promotion/seminar/naver.svg"
                alt="naver"
              />
              네이버지도 보기
            </MapButton>
            <MapButton
              onClick={() =>
                window.open('https://kko.kakao.com/k5DozC3Pm-', '_blank')
              }
            >
              <img
                src="/assets/images/promotion/seminar/kakao.svg"
                alt="kakao"
              />
              카카오맵 보기
            </MapButton>
          </MapButtonWrapper>
        </Section>

        <LandingFooter data={footerData} moreSection={footerMoreSection} />
        <Footer />
      </Container>
    </Component>
  );
}

export default Seminar;

type SectionWrapperProps = {
  $padding?: number;
  $gap?: number;
  $bg?: string;
  $paddingBottom?: number;
};

type SectionTitleProp = {
  $color?: string;
  $center?: boolean;
};

type CompareCardProp = {
  $isBefore?: boolean;
};

const Component = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  word-break: keep-all;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
`;

const Container = styled.div`
  user-select: none;
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  height: 56px;
  padding: 16px 20px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
`;

const HeaderIconButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
`;

const Keyvisual = styled.div`
  width: 100%;
  background: #000;
  overflow: hidden;
  position: relative;
`;

const MainImg = styled.div`
  background: url('/assets/images/promotion/seminar/main.png') no-repeat
    center / contain;
  width: 100%;
  aspect-ratio: calc(360 / 365);
`;

const LeftTimeSection = styled.div`
  display: flex;
  width: 100%;
  padding: 20px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  background: #00f0ff;
`;

const LeftTimeTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  color: #000;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.4px;
`;

const LeftTimeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const LeftTime = styled.div`
  background: url('/assets/images/promotion/seminar/time-wrapper.svg') no-repeat
    center / cover;
  width: 66px;
  height: 59px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  color: #000;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.48px;
`;

const LeftTimeHour = styled(LeftTime)`
  background: url('/assets/images/promotion/seminar/time-wrapper-hour.svg')
    no-repeat center / cover;
  width: 88px;
  height: 59px;
`;

const Section = styled.div<SectionWrapperProps>`
  display: flex;
  width: 100%;
  min-width: 360px;
  padding: ${({ $padding, $paddingBottom }) =>
    $paddingBottom
      ? `${$padding}px 16px ${$paddingBottom}px`
      : `${$padding}px 16px`};
  background: ${({ $bg }) => $bg};
  flex-direction: column;
  align-items: center;
  gap: 40px;
  gap: ${({ $gap }) => `${$gap}px`};
`;

const SectionTitle = styled.div<SectionTitleProp>`
  color: ${({ $color }) => $color};
  text-align: center;
  font-family: 'Gmarket Sans';
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: -1.04px;
`;

const SectionTitlePretendard = styled.div<SectionTitleProp>`
  width: 100%;
  font-family: Pretendard;
  text-align: ${({ $center }) => $center && 'center'};
  font-size: 26px;
  font-weight: 700;
  line-height: 140%;
  letter-spacing: -1.04px;
  color: ${({ $color }) => ($color ? $color : '#000')};
`;

const ProblemsWrapper = styled.div`
  display: flex;
  padding: 40px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 4px 30px 0 rgba(0, 13, 57, 0.2);
`;

const Problems = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  color: #000;
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%;
`;

const Warn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const WarnText = styled.div`
  color: #fff;
  text-align: center;
  font-family: 'Gmarket Sans';
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: -1.04px;

  & > span {
    color: #f7d614;
    font-family: 'Gmarket Sans';
    font-size: 26px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: -1.04px;
  }
`;

const CompareImg = styled.img`
  width: 100%;
  aspect-ratio: 43/35;
`;

const ZipgoVideo = styled.video`
  width: 100%;
  max-width: 500px;
  flex-shrink: 0;
  aspect-ratio: 41/23;
`;

const PointWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
`;

const PointContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const PointImgWrapper = styled.div`
  position: relative;
`;

const InteractionVideo = styled.video`
  height: 576px;
  width: auto;
  flex-shrink: 0;

  border-radius: 40px;
  border: 4px solid #e1e2e4;
  background: #fff;
`;

const PointImg = styled.img`
  height: 576px;
  flex-shrink: 0;
  aspect-ratio: 9/20;

  border-radius: 40px;
  border: 4px solid #e1e2e4;
  background: #fff;
`;

const PointContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const PointTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  color: #000;
  text-align: center;
  font-family: Pretendard;
  font-size: 24px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.48px;
`;

const PointTitleNumber = styled.div`
  color: #0ca8b1;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const PointDesc = styled.div`
  color: #616161;
  text-align: center;
  font-family: 'Wanted Sans';
  font-size: 18px;
  font-weight: 600;
  line-height: 140%;
  letter-spacing: -0.36px;
`;

const SeminarProcedureHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;

const SeminarProcedureHeaderDesc = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  color: #000;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.3px;
`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
`;

const CheckBox = styled.div`
  display: flex;
  padding: 20px;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #00f0ff;
  background: #e5fdff;

  color: #000;
  font-family: Pretendard;
  font-size: 20px;
  font-weight: 700;
  line-height: 145%;
`;

const Map = styled.img`
  width: 100%;
  aspect-ratio: calc(328 / 523);

  border-radius: 20px;
  background: #edeabe;
`;

const LocationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const LocationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const Location = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  color: #000;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
`;

const Subway1 = styled.div`
  display: flex;
  width: 18px;
  height: 18px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 999px;
  background: #263c96;

  color: #fff;
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
`;

const MapButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const MapButton = styled.div`
  display: flex;
  padding: 16px 24px;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  border-radius: 999px;
  border: 1px solid #e5e8ea;
  background: #1f1f1f;

  color: #fff;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 600;
  line-height: 145%;
  letter-spacing: -0.32px;

  & > img {
    border-radius: 4px;
    width: 16px;
    height: 16px;
    aspect-ratio: 1/1;
  }
`;

const BottomFloating = styled.div`
  position: fixed;
  z-index: 15;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  width: 100%;
  padding: 16px;
  align-items: center;
  gap: 8px;
  background: #333;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
`;

const FloatingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
`;

const FloatingText = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  align-self: stretch;

  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const FloatingTimeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const FloatingLeftTime = styled.div`
  display: flex;
  padding: 4px 6px;
  justify-content: center;
  align-items: center;
  background: #fff;

  color: #0ca8b1;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const FloatingButton = styled.button`
  display: flex;
  padding: 14px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  border: none;
  outline: none;
  background: #00f0ff;
  /* cursor: pointer; */

  color: #000;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
`;
